<template>
  <ValidationProvider name="Audience Id" slim vid="facebook_audience_id" rules="required">
    <template #default="{ errors }">
      <BaseFormGroup>
        <BaseFormLabel for="facebook_audience_id"> Audience Id </BaseFormLabel>
        <BaseFormInput id="facebook_audience_id" v-model="audienceId" :disabled="disabled" />
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </BaseFormGroup>
    </template>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    disabled: Boolean,
  },
  computed: {
    audienceId: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
